import { useState, useEffect } from "react";
import { useAuthService } from "../Context/AuthContext";

/**
 * Manages project selection for a given tool product slug.
 *
 * When a user belongs to a single project with the tool, it auto-selects.
 * When multiple projects qualify, the caller can render a selector using
 * the returned `projects` list and `setSelectedId`.
 */
const useToolProject = (slug) => {
  const { toolProjectIds } = useAuthService();
  const projects = toolProjectIds?.[slug] || [];
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (projects.length === 0 || selectedId !== null) return;

    const pendingId = sessionStorage.getItem("pendingToolProjectId");
    if (pendingId) {
      sessionStorage.removeItem("pendingToolProjectId");
      const match = projects.find((p) => String(p.id) === String(pendingId));
      if (match) {
        setSelectedId(match.id);
        return;
      }
    }

    setSelectedId(projects[0].id);
  }, [projects, selectedId]);

  return {
    projectId: selectedId,
    projects,
    setSelectedId,
    isMultiple: projects.length > 1,
  };
};

export default useToolProject;
